import { render, staticRenderFns } from "./OrderBarrelConsignee.vue?vue&type=template&id=17eb3fc2&"
import script from "./OrderBarrelConsignee.vue?vue&type=script&lang=js&"
export * from "./OrderBarrelConsignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports